import { bff, toClientError } from './bff'

const run = (p) => p.then((r) => r.data).catch((e) => Promise.reject(toClientError(e)))

// ---- Per-call defaults (BFF-owned store) ----
export const getDefaults = () => run(bff.get('/api/settings/defaults'))
export const putDefaults = (patch) => run(bff.put('/api/settings/defaults', patch))

// ---- Engine config (read-only aggregate; transcribe is editable) ----
export const getEngineSettings = () => run(bff.get('/api/settings/engines'))
export const putTranscribeConfig = ({ llm, prompts }) =>
  run(bff.put('/api/settings/engines/transcribe', { llm, prompts }))
